import { RequestStatusEnum } from '@/helpers/consts';

export default {
    profile: null,
    profileRequestStatus: RequestStatusEnum.IDLE,
};
